import { AnyAction } from 'redux';
import { createRoutine } from 'redux-saga-routines';
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { get } from 'lodash/fp';
import { ICMSResponse, ICMSResponseBody } from '@whitelabel/helpers/types';
import api, { API_HOST } from '../helpers/api';

export const getPageSegments = createRoutine('pageSegments/GET_PAGE_SEGMENTS');

/**
 * This function will aggregate the body values from the segments coming from CMS
 * @param segments This is the segments coming from XCMS. Each segment is a static page
 * @returns This will return an array that contains the body object from each page segment.
 */
export const aggregateSegments = (segments: ICMSResponse): ICMSResponseBody[] =>
  Object.values(segments).map((val) => val.body[0]);

function* handleGetPageSegments({ payload: slug }: AnyAction) {
  try {
    // @ts-expect-error fix type for yield
    const locale = yield select(get('intl.locale'));
    const searchParams = new URLSearchParams({ language: locale });
    yield put(
      getPageSegments.request({
        slug,
      }),
    );
    const segments: ICMSResponse = yield call(api.get, `${API_HOST}/page_segments/${slug}/?${searchParams}`);
    const page = aggregateSegments(segments);
    yield put(getPageSegments.success({ locale, slug, page }));
  } catch (error) {
    yield put(getPageSegments.failure({ slug, error }));
  } finally {
    yield put(getPageSegments.fulfill({ slug }));
  }
}

export function* pageSegmentsSaga() {
  yield takeLatest(getPageSegments.TRIGGER, handleGetPageSegments);
}
